var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.32 10.6685C36.3033 11.3585 35.7317 11.9052 35.0417 11.8902C34.3517 11.8735 33.805 11.3018 33.82 10.6118L33.8883 7.60184L30.88 7.5335C30.19 7.51684 29.6433 6.94517 29.6583 6.25517C29.675 5.56517 30.2467 5.0185 30.9367 5.0335L35.1967 5.13184C35.8867 5.14684 36.4333 5.7185 36.4167 6.4085L36.32 10.6685Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71165 15.5777V35.8127C9.71165 36.976 8.76998 37.9177 7.60665 37.9177H4.18831C3.02498 37.9177 2.08331 36.976 2.08331 35.8127V15.5777C2.08331 14.416 3.02498 13.4727 4.18831 13.4727H7.60665C8.76998 13.4727 9.71165 14.416 9.71165 15.5777Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.515 25.8335V35.8118C28.515 36.3702 28.2933 36.9052 27.8983 37.3002C27.5033 37.6952 26.9683 37.9168 26.41 37.9168H22.9917C22.4333 37.9168 21.8983 37.6952 21.5033 37.3002C21.1083 36.9052 20.8867 36.3702 20.8867 35.8118V25.8335C20.8867 25.2752 21.1083 24.7402 21.5033 24.3452C21.8983 23.9502 22.4333 23.7285 22.9917 23.7285H26.41C26.9683 23.7285 27.5033 23.9502 27.8983 24.3452C28.2933 24.7402 28.515 25.2752 28.515 25.8335Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1133 20.7046V35.8113C19.1133 36.9746 18.1717 37.9163 17.0083 37.9163H13.59C12.4267 37.9163 11.485 36.9746 11.485 35.8113V20.7046C11.485 20.1463 11.7067 19.6113 12.1017 19.2163C12.4967 18.8213 13.0317 18.5996 13.59 18.5996H17.0083C18.1717 18.5996 19.1133 19.5429 19.1133 20.7046Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9167 20.7046V35.8113C37.9167 36.9746 36.975 37.9163 35.8117 37.9163H32.3933C31.23 37.9163 30.2883 36.9746 30.2883 35.8113V20.7046C30.2883 20.1463 30.51 19.6113 30.905 19.2163C31.3 18.8213 31.835 18.5996 32.3933 18.5996H35.8117C36.975 18.5996 37.9167 19.5429 37.9167 20.7046Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0833 4.3335C3.52997 3.92016 3.4183 3.13516 3.8333 2.5835C4.24663 2.03183 5.02997 1.92016 5.5833 2.3335L15.505 9.77516H20.2166C20.6016 9.77516 20.9633 9.95183 21.2 10.2535L25.0116 15.1052L33.845 5.88683C34.3216 5.3885 35.1133 5.37183 35.6116 5.85016C36.11 6.32683 36.1266 7.1185 35.65 7.61683L25.82 17.8735C25.57 18.1352 25.2183 18.2752 24.8566 18.2568C24.495 18.2402 24.1583 18.0652 23.935 17.7802L19.61 12.2752H15.0883C14.8183 12.2752 14.555 12.1885 14.3383 12.0252L4.0833 4.3335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2);
export default __webpack_public_path__ + "static/media/s2.b20e046a9c2ad5b7804646549b1d8052.svg";
export { ForwardRef as ReactComponent };